import PropTypes from 'prop-types';

const Card = ({ className, variant, children }) => (
  <div
    className={`cef-ui-card${variant ? ` cef-ui-card--${variant}` : ''}${
      className ? ` ${className}` : ''
    }`}>
    {children}
  </div>
);

Card.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['small', 'large']).isRequired,
  children: PropTypes.node.isRequired,
};

export default Card;
